import auth0 from 'auth0-js'
import Vue from 'vue'

import authHttpHelper from './auth-http-helper'

import gql from 'graphql-tag'

import myQueries from '../hasura/myQueries'

let callBackURL = process.env.VUE_APP_CALL_BACK_URL_OLD;

// let callBackURL = process.env.VUE_APP_CALL_BACK_SERVER_URL;

// console.log(`callBackURL: ${callBackURL}`);

if(process.env.NODE_ENV == 'development' && process.env.VUE_APP_SERVER_MY_MODE == 'development'){

  callBackURL = process.env.VUE_APP_CALL_BACK_URL;
}
else if(process.env.NODE_ENV == 'production' && process.env.VUE_APP_SERVER_MY_MODE == 'production'){

  callBackURL = process.env.VUE_APP_CALL_BACK_SERVER_URL;
}



// exchange the object with your own from the setup step above.
let webAuth = new auth0.WebAuth({
  domain: process.env.VUE_APP_DOMAIN,
  clientID: process.env.VUE_APP_CLIENT_ID,
  // make sure this line is contains the port: 8080

redirectUri: callBackURL,
  // redirectUri: 'http://localhost:3000/callback',
  // redirectUri: 'http://localhost:8080/callback',
    // redirectUri: 'https://pnadi.com/callback',


  // redirectUri: 'https://p-nadi-website.appspot.com/callback',

    // redirectUri: 'http://localhost:3000',

  // we will use the api/v2/ to access the user information as payload
//   audience: 'https://' + 'your_auth0_domain' + '/api/v2/', 
//   audience: 'https://' + process.env.VUE_APP_DOMAIN + '/pnadiapi/', 

  responseType: 'token id_token', 
  // responseType: 'token id_token code',
    // responseType: 'code',

    // scope: 'openid email profile' // define the scopes you want to use

  scope: 'openid offline_access email profile' // define the scopes you want to use
})

let auth = new Vue({
  computed: {
    // token: {
    //   get: function() {
    //     return localStorage.getItem('id_token')
    //   },
    //   set: function(id_token) {
    //     localStorage.setItem('id_token', id_token)
    //   }
    // },
    // accessToken: {
    //   get: function() {
    //     return localStorage.getItem('access_token')
    //   },
    //   set: function(accessToken) {
    //     localStorage.setItem('access_token', accessToken)
    //   }
    // },
    // expiresAt: {
    //   get: function() {
    //     return localStorage.getItem('expires_at')
    //   },
    //   set: function(expiresIn) {
    //     let expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime())
    //     localStorage.setItem('expires_at', expiresAt)
    //   }
    // },
    // user: {
    //   get: function() {
    //     return JSON.parse(localStorage.getItem('user'))
    //   },
    //   set: function(user) {
    //     localStorage.setItem('user', JSON.stringify(user))
    //   }
    // },
    
    key: {
        get: function() {

          // console.log(`in auth get email with: ${localStorage.getItem('for_pnadi')}`);

          return localStorage.getItem('for_pnadi')
        },
        set: function(value) {

          // console.log(`key: ${value}`)
          localStorage.setItem('for_pnadi', value)
        }
      },

      name: {
        get: function() {
          return localStorage.getItem('name')
        },
        set: function(name) {
          localStorage.setItem('name', name)
        }
      },
  },
  methods: {  

   async login() {
      
    let myKey = this.key;

    this.loading = true;
    
      if(!myKey && myKey != null && myKey != '')
      {
          // console.log(`im in auth-login with email ${this.email}`);
          // return;
          await this.getAuthInfo();

          if(!this.isAuthenticated())
          {
              // console.log(`im in login for auth`);

              webAuth.authorize()
          }
      }
      else{
          
        // console.log(`im in auth-else`);
        // return;
          webAuth.authorize()
      }

    this.loading = false;
    },
    async logout() {

      let myKey = this.key;

      this.key = '';

      this.name = '';
      
      //await authHttpHelper.deleteAll(myEmail);
      const federated = true;

      webAuth.logout({
        federated: federated
      });

      // console.log(`federated: ${federated}`);

      localStorage.clear()
      
      // webAuth.logout({
      //   returnTo: '/',
      //   clientID: process.env.VUE_APP_CLIENT_ID,
      // });

      // webAuth.logout({
      //   // returnTo: 'http://SOMEWHERE.ELSE.com', // Allowed logout URL listed in dashboard
        

      //   returnTo: 'http://localhost:3000/', // Allowed logout URL listed in dashboard
      //   clientID: 'process.env.VUE_APP_CLIENT_ID', // Your client ID
      // });

      // return new Promise((resolve, reject) => { 
      //   // localStorage.removeItem('access_token')
      //   // localStorage.removeItem('id_token')
      //   // localStorage.removeItem('expires_at')
      //   // localStorage.removeItem('user')
        
      //   webAuth.logout({
      //     // returnTo: 'http://SOMEWHERE.ELSE.com', // Allowed logout URL listed in dashboard
          

      //     returnTo: 'http://localhost:3000/', // Allowed logout URL listed in dashboard
      //     clientID: 'process.env.VUE_APP_CLIENT_ID', // Your client ID
      //   });
      // })

      // console.log('finished logout to home');

    },

     async isAuthenticated() {

      //to do
      // if (process.env.NODE_ENV === "development") {
        
      //   cons
      //   return true;
      // }
      
      if(this.expiresAt === null || this.expiresAt == ''){

        let myKey = this.key;

        // console.log(`im inside isAuthenticated and email is ${myEmail}`);


        if(myKey && myKey != null && myKey != '')
        {

            // console.log(`im inside isAuthenticated and key is ${myKey}`);
            
           const userInfo = await this.getAuthInfo();

            // const userInfo = await this.getAuthInfo();

            // console.log(`im inside isAuthenticated and key is ${myKey} && userInfo is ${JSON.stringify(userInfo)}`);

        }
        else {
          
          return false;
        }
      }

     // let time = new Date().getTime();
      let expiresAtTime = new Date(this.expiresAt).getTime();
      // console.log(`im inside isAuthenticated and time is: ${time} and expiryTime is  ${expiresAtTime}`);
      
      // console.log(new Date().getTime() < expiresAtTime);

      // return new Date().getTime() (24 * 60 * 60 * 1000) < this.expiresAt

      return new Date().getTime() < expiresAtTime
    },

    async handleAuthentication() {

        // console.log('Im in authentication');

      return new Promise((resolve, reject) => {  
        webAuth.parseHash(async (err, authResult) => {

          if (authResult && authResult.accessToken && authResult.idToken) {
              
            // console.log(`after authentication the result is ${JSON.stringify(authResult)}`);
            // console.log(`after authentication the keys are ${Object.keys(authResult)}`);

            // console.log(`after authentication the payload is ${JSON.stringify(authResult.idTokenPayload)}`);

            // console.log(`after authentication the email is ${authResult.idTokenPayload.email}`);


            this.expiresAt = authResult.expiresIn;
            this.accessToken = authResult.accessToken;
            this.refreshToken = authResult.refreshToken;
            this.token = authResult.idToken;
            // this.user = authResult.idTokenPayload;
            //this.email = authResult.idTokenPayload.email;
            this.userEmail = authResult.idTokenPayload.email;

            // console.log(`after authentication the auth-in email is ${this.userEmail}`);


            // this.sleep(1000);

            // while(this.email === ''){

            //   await this.sleep(1000);
            //   this.email = authResult.idTokenPayload.email;
            // }
            this.name = authResult.idTokenPayload.name;

            // console.log(`after authentication the payload is ${JSON.stringify(this.user)}`);

            // console.log(`after authentication thee payload is ${Object.keys(this.user)}`);


            // this.email = this.getEmailFromHasuraUserToken(apollo);

            let result = await this.setAuthInfo(this.userEmail);


          await this.getAuthInfo();

          // console.log(`In Auth - handleAuthentication, and userInfo is ${JSON.stringify(userInfo)}`);

         // console.log(`Inside handle authentication and information has been set`);

            resolve(result);

          } else if (err) {
            await this.logout()
            reject(err)
          }

        })
      })
    },

    // async getEmailFromHasuraUserToken(apollo){

    //   this.loading = true;

    //     let tokenResult = await apollo.query({
    //         query: myQueries.token_query,
    //         error(error){
    //             this.tokenError = JSON.stringify(error);
    //         },   
    //     });

    //     this.loading = false;
    //     return tokenResult.data.token[0].email;
    // },

    // getKey(){

    //   return this.key;
    // },

    async getAuthInfo(){

        if(this.token === '' || !this.token)
        {

          // console.log(`from getAuthInfo saved key is ${this.key}`);

         let myKey = this.key;

         if(typeof myKey == 'undefined' || myKey == 'undefined'){

          this.logout();
         }

        //  console.log(`key : ${typeof myKey}`);

          this.loading = true;
          let result = await authHttpHelper.getAll(myKey);
  
            //  console.log(`Im in getAuthInfo with result: ${JSON.stringify(result)}`);
            //  console.log(`Im in auth with result: ${Object.keys(result.data)}`);
          
          this.key = result.data.key;
          this.token = result.data.tokenId;
          this.accessToken = result.data.accessToken;
          this.expiresAt = result.data.expires;
  
          this.loading = false;
        }

        return {
          email: this.key,
          token: this.token,
          accessToken: this.accessToken,
          expiresAt: this.expiresAt
        };
    },

    async setAuthInfo(key){

      // console.log(`key: ${key}`);

      this.loading = true;
      
      let result = await authHttpHelper.setAll(key, this.token, this.accessToken, this.refreshToken);

      this.key = result.data.key,
      this.token = result.data.tokenId;
      this.accessToken = result.data.accessToken;
      this.expiresAt = result.data.expires;

      this.loading = false

      // console.log(`from setAuthInfo result email is ${result.email}`);

      // console.log(`from setAuthInfo saved email is ${this.email}`);
    },

    async sleep(ms){
       
      return await new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  data: function(){
    
    return{
       
        token: '',
        accessToken: '',
        expiresAt: null,
        refreshToken: '',
        userEmail: '',
        // user: null,
        loading: false,
        
        // emailSaved: false
    }
   
  }
})

export default {
  install: function(Vue) {
    // console.log(`auth from in`);
    // console.log(Object.keys(auth));

    // console.log(auth);
    Vue.prototype.$auth = auth
  },
}